import Tabs from './Tabs';
import TabItem from './TabItem';

export default Tabs;
export { TabItem };
